import React, { createContext, useContext, useState } from 'react';

export const GlobalContext = createContext();

export default function GlobalContextProvider({ children }) {
    const params = new URLSearchParams(window.location.search);
    const [branch, setBranch] = useState(null);
    const [practitioners, setPractitioners] = useState([]);
    const [appointmentTypes, setAppointmentTypes] = useState([]);
    const [windowNumber, setWindowNumber]  = useState(0);
    const [selectedType, setSelectedType] = useState({ID:""});
    const [isMobile, setIsMobile] = useState(false);
    const [bookingSubmitting, setBookingSubmitting] = useState(false);
    const [bookingSuccess, setBookingSuccess] = useState(false);
    const [bookingExists, setBookingExists] = useState(false);  
    const [currentPractitioners, setCurrentPractitioners] = useState([]);
    const [windowMovedBack, setWindowMovedBack] = useState(false);
    const [numAvailablePractitioners, setNumAvailablePractitioners] = useState(0);
    const [isClasses, setIsClasses] = useState(false);
    const [loadedClasses, setLoadedClasses] = useState(false);

    const [bookingDetails, setBookingDetails] = useState({
      'email': '',
      'DOB': '',
      'firstName': '',
      'lastName': '',
      'phone': '',
      'gender': 'Male',
      'visited': 'No',
     });

    const handleWindowChange = (isNext) => {
      
      if (isNext && windowNumber < 3) {
        setWindowMovedBack(false);
        setWindowNumber(windowNumber + 1);
      } else {
        setWindowMovedBack(true);
        setWindowNumber(windowNumber - 1);
      }
    }

    return (
        <GlobalContext.Provider value={{ 
            windowNumber, 
            setWindowNumber,
            selectedType,
            setSelectedType,
            practitioners,
            setPractitioners,
            appointmentTypes,
            setAppointmentTypes,
            branch,
            setBranch,
            bookingDetails,
            setBookingDetails,
            handleWindowChange,
            params,
            isMobile,
            setIsMobile,
            bookingSubmitting,
            setBookingSubmitting,
            bookingSuccess,
            setBookingSuccess,
            currentPractitioners,
            setCurrentPractitioners,
            windowMovedBack,
            setWindowMovedBack,
            numAvailablePractitioners,
            setNumAvailablePractitioners,
            bookingExists,
            setBookingExists,
            isClasses,
            setIsClasses,
            loadedClasses,
            setLoadedClasses
        }}>
            {children}
        </GlobalContext.Provider>
    );
}

export function useGlobalContext() {
    const context = useContext(GlobalContext);
    if (!context) {
        throw new Error('useGlobalContext must be used within a GlobalProvider');
    }
    return context;
}